import { FC } from 'react';
import { Alert } from 'antd';

interface ErrorMessageProps {
  error: Error;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
  return (
    <div style={{ padding: '20px' }}>
      <Alert
        message="오류가 발생했습니다"
        description={error.message}
        type="error"
        showIcon
      />
    </div>
  );
};

export default ErrorMessage;